import { RepairShop } from "../../../model/RepairShop";
import { axiosUtils } from "../../../network/axiosUtils";
import httpRequest from "../../../network/httpRequest";
import { HttpResponse } from "../../../network/types";

import { MESSAGE_KIND } from "../../Login/apis/constants";
import {
  CheckTokenRequest,
  SendPhoneNumberRequest,
} from "../../Login/apis/types";
import { ResetPassRequest } from "./types";

export const resetPass = async (requestBody: ResetPassRequest) => {
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.PUT,
    url: `/repair-shop/reset-password`,
    requestBody: {
      ...requestBody,
      newPassword: requestBody.newPass,

      repairShopId: requestBody.repairShopId,
    },
  });
  return response?.data;
};
export const checkDuplicatiedId = async (queryParams: { aId: string }) => {
  const response = await httpRequest({
    method: axiosUtils.GET,
    url: `/repair-shop/duplication-check`,
    queryParams,
  });
  return response;
};
export const sendPhoneNumber = async (props: SendPhoneNumberRequest) => {
  const requestBody = {
    ...props,
    type: "message",
    kind: MESSAGE_KIND,
  };
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.POST,
    url: `/auth-tokens`,
    requestBody,
  });
  return response?.data.row;
};
export const checkPhoneAuth = async (props: CheckTokenRequest) => {
  const requestBody = {
    ...props,
    type: "message",
    kind: MESSAGE_KIND,
  };
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.POST,
    url: `/access-tokens`,
    requestBody,
  });
  return response?.data.row;
};
export const verifyPhone = async (props: any): Promise<RepairShop> => {
  const queryParams = {
    ...props,
  };
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.GET,
    url: `/repair-shop/verify-phone`,
    queryParams,
  });
  return response?.data.row;
};
